import React, { useState } from "react";
import "./ContactUs.css";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import RedRoundBtn from "../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Contact_Success_Modal from "../Common_Component/Common_Modal/Contact_Success_Modal/Contact_Success_Modal";
import { ContactUsForm } from "../../utils/apis/form/form";
import { RegxExpression } from "../../utils/common";
const ContactUs = () => {
  const [showModal, setShowModal] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("message", data?.message);

    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);

    const res = await ContactUsForm(formData);
    if (res?.success) {
      reset();
      setShowModal(true);
    } else {
    }
  };
  return (
    <section className="ContactUs">
      <div className="container-fluid p-0">
        <div className="banner_img_holder">
          <img
            src={"/assets/Image/ContactUs/banner.png"}
            className="banner_img"
            alt="Banner"
          />
        </div>
      </div>

      <div className="form_container">
        <div className="container">
          <p className="title_text">
            Get our experts to answer your questions within 24 Hrs.
          </p>

          <div className="form_card">
            <Form className="contctus_form" onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="blue_label_group">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Full Name*"
                  {...register("name", {
                    required: "Name is required",
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.name.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="blue_label_group">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: RegxExpression.email,
                      message: "Invalid email address",
                    },
                  })}
                />
                {errors?.email && (
                  <span className="invalid-feedback d-block">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="blue_label_group">
                <Controller
                  country="in"
                  name="contact_no"
                  control={control}
                  rules={{
                    required: "contact_no is required",
                    minLength: {
                      value: 10,
                      message: "Number should be at least 10 characters",
                    },
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      country={"in"}
                      {...field}
                      onChange={(value) => field.onChange(value)}
                      type="text"
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                      onKeyDown={(event) => {
                        if (
                          !RegxExpression.phone.test(event.key) &&
                          event.key !== "Backspace" &&
                          event.key !== "ArrowLeft" &&
                          event.key !== "ArrowRight"
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                  )}
                />
                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}
              </Form.Group>

              <Form.Group className="blue_label_group">
                <Form.Control
                  type="text"
                  as={"textarea"}
                  placeholder="Write your message here"
                  name="message"
                  {...register("message", {
                    required: "Message is required",
                  })}
                />
                {errors?.message && (
                  <span className="invalid-feedback d-block">
                    {errors.message.message}
                  </span>
                )}
              </Form.Group>

              <div className="btn_holder">
                <RedRoundBtn
                  type="submit"
                  btn_name="Contact Us"
                  //   onClick={() => {
                  //     setShowModal(true);
                  //   }}
                />
              </div>
            </Form>
          </div>
        </div>
      </div>

      {showModal && (
        <Contact_Success_Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          title="Glad to know your interest to explore!"
          subtitle="Soon we will get back to you!"
        />
      )}
    </section>
  );
};

export default ContactUs;
